import {Locale, Markets} from "../generated/graphql";

export const getMarket = (market: any): string => {
  return Markets[market as Markets];
};

export const getLocale = (market: any): string => {
  return market === 'global' ? Locale['default'] : (Locale[market as Locale] || Locale['default']);
};
